<template>
  <div
    v-if="prompt.show"
    class="BcPrompt fixed inset-0 overflow-y-auto"
    :class="{ 'BcPrompt--Visible': prompt.show }"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      />
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >
        &#8203;
      </span>
      <div
        class="BcPromptContent inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
        :class="{ 'BcPromptContent--Visible': prompt.show }"
      >
        <div>
          <div
            v-if="prompt.withIcon"
            class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-3"
          >
            <svg
              class="h-6 w-6 text-green-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <div class="text-center">
            <h3 class="text-lg leading-6 font-medium text-gray-800">
              {{ prompt.header }}
            </h3>
            <div 
              class="form-group"
              :class="{'is-invalid' : showError}"
            >
              <textarea
                :placeholder="prompt.placeholder"
                class="form-control mt-4"
                v-model="prompt.value"
              />
              <div 
                v-if="showError"
                class="invalid-feedback text-left"
              >
                {{ $t('Required') }}
              </div>
            </div>
            <div class="mt-2">
              <p class="text-sm text-gray-500" v-if="prompt.text && prompt.text != ''">
                {{ prompt.text }}
              </p>
            </div>
          </div>
        </div>
        <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
          <button
            type="button"
            class="btn btn-primary w-full inline-flex justify-center sm:col-start-2 sm:text-sm"
            :class="prompt.class"
            @click="prompt.ok"
          >
            {{$t(prompt.buttonYes)}}
          </button>
          <button
            type="button"
            class="btn btn-secondary mt-3 w-full inline-flex justify-center sm:mt-0 sm:col-start-1 sm:text-sm"
            @click="prompt.cancel"
          >
            {{$t(prompt.buttonNo)}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
const defaults = {
  show: false,
  header: 'Example prompt!',
  text: null,
  buttonNo: 'No',
  buttonYes: 'Yes',
  class: null,
  withIcon: false,
  required: null,
  placeholder: null,
  value: '',
}

const prompt = ref({...defaults})

export function showPrompt (config) {
  const newPrompt = {...defaults, ...config}
  return new Promise((resolve) => {
    newPrompt.show = true
    newPrompt.ok = () => {
      if (newPrompt.required) {
        if (newPrompt.value) {
          prompt.value.show = false
          resolve(prompt.value.value)
        }
      } else {
        prompt.value.show = false
        resolve(prompt.value.value)
      }
    }
    newPrompt.cancel = () => {
      prompt.value.show = false
      resolve(false)
    }
    prompt.value = newPrompt
  })
}

export default {
  setup() {
    return {
      prompt: prompt
    }
  },
  computed: {
    showError() {
      return this.prompt.required && !this.prompt.value
    },
  },
}
</script>

<style scoped>
.BcPrompt {
  z-index: 9999;
}
</style>
